export enum TestCategory {
    COMMISSIONING = "COMMISSIONING",
    DIAGNOSTIC = "DIAGNOSTIC"
}